export default __webpack_public_path__ + "static/media/tsa-painting.b5d1670c.jpg";